<div class="mt-32" *ngIf="emailOptInData">
  <div>
    <h3 class="modal-title">{{ 'form-builder.legos.email-optin.header.title' | translate | titlecase }}</h3>
    <p class="light-text">{{ 'form-builder.legos.email-optin.header.description' | translate | ucfirst }}</p>
  </div>
  <div class="mt-24 mct-flex mct-col mct-gap-5"  >
    <label class="title"> {{ 'form-builder.legos.email-optin.label.text' | translate | titlecase }} </label>
    <span class="help-block">{{ 'form-builder.legos.email-optin.label.help-text' | translate | ucfirst }}</span>
    <input
      name="email-optin-label"
      [(ngModel)]="emailOptInData.Label"
      [placeholder]="'form-builder.legos.email-optin.label.default' | translate | ucfirst"
      [required]="true"
    />
  </div>
  <div class="mt-24 mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.email-optin.message.text' | translate | titlecase }} </label>
    <wl-simple-html-editor name="email-optin-message" [(ngModel)]="emailOptInData.Message"></wl-simple-html-editor>
  </div>
</div>
